// import { getMobileOperatingSystem } from '@utils/customLib';

// const isIOS = getMobileOperatingSystem === 'iOS';

const getReferenceElementCoordinates = el => {
	const rect = el.getBoundingClientRect();
	const a = {
		top: rect.top,
		left: rect.left,
		width: el.offsetWidth,
		height: el.offsetHeight,
	};
	// const { offsetTop } = el;

	a.right = rect.right || a.left + a.width;
	a.bottom = rect.bottom || a.top + a.height;
	// a.bottom =
	// 	(isIOS ? offsetTop + a.height : rect.bottom) ||
	// 	(isIOS ? offsetTop : a.top) + a.height;
	a.center = a.left + (a.right - a.left) / 2;
	a.middle = a.top + (a.bottom - a.top) / 2;
	return a;
};

const getPopperElementPosition = (
	position,
	referenceElRect,
	popperElRect,
	gap,
	arrowPadding
) => {
	let popperElTop, popperElLeft;
	switch (position) {
		case 'top':
			popperElTop =
				referenceElRect.top - popperElRect.height - gap - arrowPadding;
			popperElLeft = referenceElRect.center - popperElRect.width / 2;
			break;
		case 'left':
			popperElTop = referenceElRect.middle - popperElRect.height / 2;
			popperElLeft =
				referenceElRect.left - popperElRect.width - gap - arrowPadding;
			break;
		case 'right':
			popperElTop = referenceElRect.middle - popperElRect.height / 2;
			popperElLeft = referenceElRect.right + gap + arrowPadding;
			break;
		case 'topRight':
			popperElTop =
				referenceElRect.top - popperElRect.height - gap - arrowPadding;
			popperElLeft = referenceElRect.left;
			break;
		case 'topLeft':
			popperElTop =
				referenceElRect.top - popperElRect.height - gap - arrowPadding;
			popperElLeft = referenceElRect.right - popperElRect.width;
			break;
		case 'bottomRight':
			popperElTop = referenceElRect.bottom + gap + arrowPadding;
			popperElLeft = referenceElRect.left;
			break;
		case 'bottomLeft':
			popperElTop = referenceElRect.bottom + gap + arrowPadding;
			popperElLeft = referenceElRect.right - popperElRect.width;
			break;
		default:
			// bottom case
			popperElTop = referenceElRect.bottom + gap + arrowPadding;
			popperElLeft = referenceElRect.center - popperElRect.width / 2;
	}
	return {
		top: popperElTop,
		left: popperElLeft,
	};
};

const getArrowElementPosition = (
	position,
	referenceElRect,
	arrowLength,
	arrowDiagonalLength,
	gap,
	padding
) => {
	let arrowElLeft, arrowElTop, arrowElBorder, arrowElClipPath;
	const arrowPositioningException =
		referenceElRect.width / 2 < arrowDiagonalLength / 2 + padding;
	const arrowRotationCorrection = arrowLength - arrowDiagonalLength / 2 - 1; // reason of 1 = border width of popper
	switch (position) {
		case 'top':
			arrowElTop =
				referenceElRect.top -
				arrowDiagonalLength -
				gap +
				arrowRotationCorrection -
				0.3;
			arrowElLeft = referenceElRect.center - arrowDiagonalLength / 2;
			arrowElBorder = '0 1px 1px 0';
			arrowElClipPath = 'polygon(0 100%, 100% 0, 100% 100%)';
			break;
		case 'left':
			arrowElTop = referenceElRect.middle - arrowDiagonalLength / 2;
			arrowElLeft =
				referenceElRect.left -
				arrowDiagonalLength -
				gap +
				arrowRotationCorrection;
			arrowElBorder = '1px 1px 0 0';
			arrowElClipPath = 'polygon(0 0, 100% 0, 100% 100%)';
			break;
		case 'right':
			arrowElTop = referenceElRect.middle - arrowDiagonalLength / 2;
			arrowElLeft = referenceElRect.right + gap + arrowRotationCorrection;
			arrowElBorder = '0 0 1px 1px';
			arrowElClipPath = 'polygon(0 0, 100% 100%, 0 100%)';
			break;
		case 'topRight':
			arrowElTop =
				referenceElRect.top -
				arrowDiagonalLength -
				gap +
				arrowRotationCorrection -
				0.3;
			arrowElLeft = arrowPositioningException
				? referenceElRect.left + arrowDiagonalLength / 2
				: referenceElRect.left + padding;
			arrowElBorder = '0 1px 1px 0';
			arrowElClipPath = 'polygon(0 100%, 100% 0, 100% 100%)';
			break;
		case 'topLeft':
			arrowElTop =
				referenceElRect.top -
				arrowDiagonalLength -
				gap +
				arrowRotationCorrection -
				0.3;
			arrowElLeft = arrowPositioningException
				? referenceElRect.right -
				  arrowDiagonalLength -
				  arrowRotationCorrection
				: referenceElRect.right - arrowDiagonalLength / 2 - 2 * padding;

			arrowElBorder = '0 1px 1px 0';
			arrowElClipPath = 'polygon(0 100%, 100% 0, 100% 100%)';
			break;
		case 'bottomRight':
			arrowElTop = referenceElRect.bottom + gap + arrowRotationCorrection;
			arrowElLeft = arrowPositioningException
				? referenceElRect.left + arrowDiagonalLength / 2
				: referenceElRect.left + padding;
			arrowElBorder = '1px 0 0 1px';
			arrowElClipPath = 'polygon(100% 0, 0 100%, 0 0)';
			break;
		case 'bottomLeft':
			arrowElTop = referenceElRect.bottom + gap + arrowRotationCorrection;
			arrowElLeft = arrowPositioningException
				? referenceElRect.right -
				  arrowDiagonalLength -
				  arrowRotationCorrection
				: referenceElRect.right - arrowDiagonalLength / 2 - 2 * padding;
			arrowElBorder = '1px 0 0 1px';
			arrowElClipPath = 'polygon(100% 0, 0 100%, 0 0)';
			break;
		default:
			// bottom case
			arrowElTop = referenceElRect.bottom + gap + arrowRotationCorrection;
			arrowElLeft = referenceElRect.center - arrowDiagonalLength / 2;
			arrowElBorder = '1px 0 0 1px';
			arrowElClipPath = 'polygon(100% 0, 0 100%, 0 0)';
	}

	return {
		top: arrowElTop,
		left: arrowElLeft,
		borderWidth: arrowElBorder,
		clipPath: arrowElClipPath,
	};
};

const getArrowWrapperElementPosition = (
	position,
	referenceElRect,
	arrowDiagonalLength,
	gap
) => {
	let arrowWrapperElMarginLeft = 0,
		arrowWrapperElMarginTop = 0,
		arrowWrapperElWidth,
		arrowWrapperElHeight;
	switch (position) {
		case 'top':
		case 'topRight':
		case 'topLeft':
			arrowWrapperElWidth = referenceElRect.width;
			arrowWrapperElHeight = gap + arrowDiagonalLength / 2;
			arrowWrapperElMarginTop = -arrowWrapperElHeight;
			break;
		case 'left':
			arrowWrapperElWidth = gap + arrowDiagonalLength / 2;
			arrowWrapperElHeight = referenceElRect.height;
			arrowWrapperElMarginLeft = -arrowWrapperElWidth;
			break;
		case 'right':
			arrowWrapperElWidth = gap + arrowDiagonalLength / 2;
			arrowWrapperElHeight = referenceElRect.height;
			arrowWrapperElMarginLeft = referenceElRect.width;
			break;
		default:
			// bottom , bottomLeft, bottomRight
			arrowWrapperElWidth = referenceElRect.width;
			arrowWrapperElHeight = gap + arrowDiagonalLength / 2;
			arrowWrapperElMarginTop = referenceElRect.height;
	}
	return {
		marginTop: arrowWrapperElMarginTop,
		marginLeft: arrowWrapperElMarginLeft,
		width: arrowWrapperElWidth,
		height: arrowWrapperElHeight,
	};
};

const isElementInViewport = pos => {
	const { bottom, left, right, top } = pos;
	const { innerWidth, innerHeight } = window;
	if (bottom < 0 || top > innerHeight || right < 0 || left > innerWidth) {
		return false;
	}
	return true;
};

export const calculatePositions = (
	referenceElement,
	popperElement,
	arrowElement,
	position,
	gap,
	padding
) => {
	if (!!referenceElement && !!popperElement) {
		const screenPadding = 15;
		// { bottom, center, height, left, middle, right, top, width }
		const referenceElRect =
			getReferenceElementCoordinates(referenceElement);

		if (isElementInViewport(referenceElRect)) {
			// { bottom, height, left, right, top, width, x, y }
			const popperElRect = popperElement.getBoundingClientRect();

			const { innerWidth, innerHeight, pageXOffset, pageYOffset } =
				window;

			const arrowLength = arrowElement ? arrowElement.offsetWidth : 0;
			const arrowDiagonalLength = Math.sqrt(2 * arrowLength ** 2);
			const arrowPadding = arrowDiagonalLength / 2 - 1.59; // 1.59 because of border width

			let newPopperElPosition = getPopperElementPosition(
				position,
				referenceElRect,
				popperElRect,
				gap,
				arrowPadding
			);

			let newArrowElPosition = arrowElement
				? getArrowElementPosition(
						position,
						referenceElRect,
						arrowLength,
						arrowDiagonalLength,
						gap,
						padding
				  )
				: { top: 0, left: 0, borderWidth: 0, clipPath: '' };

			let newArrowWrapperElPositon = getArrowWrapperElementPosition(
				position,
				referenceElRect,
				arrowDiagonalLength,
				gap
			);

			// correction if popper gets out of viewport

			//correction left-right
			if (newPopperElPosition.left < screenPadding) {
				switch (position) {
					case 'left':
					case 'right':
						newPopperElPosition.left =
							referenceElRect.right + gap + arrowPadding;
						// shifting arrow to right side
						if (arrowElement) {
							newArrowElPosition = getArrowElementPosition(
								'right',
								referenceElRect,
								arrowLength,
								arrowDiagonalLength,
								gap,
								padding
							);
						}
						newArrowWrapperElPositon =
							getArrowWrapperElementPosition(
								'right',
								referenceElRect,
								arrowDiagonalLength,
								gap
							);
						break;
					default:
						newPopperElPosition.left = screenPadding;
				}
			} else if (
				newPopperElPosition.left + popperElRect.width >
				innerWidth - screenPadding
			) {
				switch (position) {
					case 'left':
					case 'right':
						newPopperElPosition.left =
							referenceElRect.left -
							popperElRect.width -
							gap -
							arrowPadding;
						// shifting arrow to left side
						if (arrowElement) {
							newArrowElPosition = getArrowElementPosition(
								'left',
								referenceElRect,
								arrowLength,
								arrowDiagonalLength,
								gap,
								padding
							);
						}
						newArrowWrapperElPositon =
							getArrowWrapperElementPosition(
								'left',
								referenceElRect,
								arrowDiagonalLength,
								gap
							);
						break;
					default:
						newPopperElPosition.left =
							innerWidth - screenPadding - popperElRect.width;
				}
			}

			// correction top-bottom
			if (newPopperElPosition.top < 0) {
				switch (position) {
					case 'left':
					case 'right':
						newPopperElPosition.top = screenPadding;
						break;
					default:
						let newPopperTop =
							referenceElRect.bottom + gap + arrowPadding;
						// check if correction is helpful
						if (newPopperTop + popperElRect.height < innerHeight) {
							newPopperElPosition.top = newPopperTop;
							// shifting arrow to bottom side
							if (arrowElement) {
								newArrowElPosition = getArrowElementPosition(
									position.replace('top', 'bottom'),
									referenceElRect,
									arrowLength,
									arrowDiagonalLength,
									gap,
									padding
								);
							}
							newArrowWrapperElPositon =
								getArrowWrapperElementPosition(
									position.replace('top', 'bottom'),
									referenceElRect,
									arrowDiagonalLength,
									gap
								);
						}
				}
			} else if (
				newPopperElPosition.top + popperElRect.height >
				innerHeight
			) {
				switch (position) {
					case 'left':
					case 'right':
						newPopperElPosition.top =
							innerHeight - popperElRect.height;
						break;
					default:
						let newPopperTop =
							referenceElRect.top -
							popperElRect.height -
							gap -
							arrowPadding;
						// check if correction is helpful
						if (newPopperTop > 0) {
							newPopperElPosition.top = newPopperTop;
							// shifting arrow to top side
							if (arrowElement) {
								newArrowElPosition = getArrowElementPosition(
									position.replace('bottom', 'top'),
									referenceElRect,
									arrowLength,
									arrowDiagonalLength,
									gap,
									padding
								);
							}
							newArrowWrapperElPositon =
								getArrowWrapperElementPosition(
									position.replace('bottom', 'top'),
									referenceElRect,
									arrowDiagonalLength,
									gap
								);
						}
				}
			}

			return {
				tooltipStyling: {
					top: `${newPopperElPosition.top + pageYOffset}px`,
					left: `${newPopperElPosition.left + pageXOffset}px`,
				},
				arrowStyling: {
					top: `${newArrowElPosition.top + pageYOffset}px`,
					left: `${newArrowElPosition.left + pageXOffset}px`,
					borderWidth: newArrowElPosition.borderWidth,
					clipPath: newArrowElPosition.clipPath,
				},
				arrowWrapperStyling: {
					marginTop: `${newArrowWrapperElPositon.marginTop}px`,
					marginLeft: `${newArrowWrapperElPositon.marginLeft}px`,
					width: `${newArrowWrapperElPositon.width}px`,
					height: `${newArrowWrapperElPositon.height}px`,
				},
			};
		}
	}
	return null;
};
